import {
    BookingflowStateMachine,
    StateName,
} from '@raskrask-dk/bookingflow-state-machine'
import { PublishType } from '@raskrask-dk/bookingflow-state-machine/lib/bookingflowstatemachine/bookingflowstatemachine.types'
import { Observer } from '@raskrask-dk/bookingflow-state-machine/lib/bookingflowstatemachine/subject'

type stateAndNotify = { stateName: StateName; action: () => void }

export const stateNotifier = (stateObservers: stateAndNotify[]): Observer => {
    return {
        id: 'EXTRAFUNC',
        notify: (state: PublishType, bfsm: BookingflowStateMachine) => {
            if (state === 'State changed') {
                stateObservers.forEach((stateObserver) => {
                    if (stateObserver.stateName === bfsm.currentState().type)
                        stateObserver.action()
                })
            }
        },
    }
}
